export default __webpack_public_path__ + "static/media/ViewDetails.6d3e4b25.svg";